<template>
  <div id="app">
    <div class="container">
      <div class="title">中山党史学习教育系列展预约系统</div>
      <div class="top-tip">
        <div v-html="topTip"></div>
        <p
          v-show="typeValue"
          class="phone-wrap"
        >
          <van-icon name="phone-o" />咨询电话：
          <span
            v-for="(item, index) in typeList"
            :key="index"
            v-show="typeIndex==index"
          >
            <a :href="'tel:'+ item.phone">{{ item.phone }}</a>({{ item.contact }})
          </span>
        </p>
      </div>
      <van-form
        @submit="onSubmit"
        class="form"
        validate-trigger="onChange"
      >
        <van-field
          readonly
          clickable
          name="type"
          :value="typeValue"
          label="展览点"
          placeholder="选择展览点"
          @click="showTypePicker=true"
          :rules="[{ required: true, message: '选择展览点' }]"
          right-icon="arrow-down"
        />
        <van-popup
          v-model="showTypePicker"
          position="bottom"
          class="van-popup--round"
        >
          <van-picker
            show-toolbar
            :columns="pickerType"
            @confirm="onConfirmType"
            @cancel="showTypePicker = false"
          />
        </van-popup>
        <van-field
          v-model="form.unit"
          name="unit"
          label="单位名称"
          :rules="[{ required: true, message: '请填写单位名称' },
          { validator, message: '单位名称不能少于三个字' }]"
          class="hastip"
        />
        <div class="line-tip">
          <van-icon name="info-o" />仅接受单位及党组织报名
        </div>
        <van-field
          v-model="form.name"
          name="name"
          label="联系人名称"
          :rules="[{ required: true, message: '请填写联系人名称' }]"
        />
        <van-field
          v-model="form.phone"
          name="phone"
          label="联系人电话"
          type="tel"
          :rules="[
            { required: true, message: '请填写联系人电话' },
            { pattern: /^1(3\d|4[5-9]|5[0-35-9]|6[567]|7[0-8]|8\d|9[0-35-9])\d{8}$/, message: '请填写正确的手机号码'}
          ]"
        />
        <van-field
          v-model="form.booking_num"
          name="booking_num"
          label="预约人数"
          type="number"
          :rules="[{ required: true, message: '请填写预约人数' },{ pattern: /^[1-9]\d*$/, message: '请填写正整数'}]"
          @input="numInputChange"
        />
        <van-field
          readonly
          clickable
          name="booking_day"
          :value="form.booking_day"
          label="预约日期"
          placeholder="点击选择日期"
          @click="dayClick"
          :rules="[{ required: true, message: '请选择预约日期' }]"
          right-icon="notes-o"
        />
        <van-calendar
          v-model="showCalendar"
          @confirm="onConfirmDay"
          color="#1989fa"
          title="预约日期"
          :formatter="formatter"
          :min-date="new Date(minDate)"
          :max-date="new Date(maxDate)"
        />

        <van-field
          readonly
          clickable
          name="booking_time"
          :value="timeValue"
          label="预约时间段"
          placeholder="点击选择时间段"
          @click="timeClick"
          :rules="[{ required: true, message: '请选择预约时间段' }]"
          right-icon="arrow-down"
        />
        <van-popup
          v-model="showTimePicker"
          position="bottom"
          class="van-popup--round"
        >
          <van-picker
            show-toolbar
            :columns="pickerTime"
            @confirm="onConfirmTime"
            @cancel="showTimePicker = false"
          />
        </van-popup>
        <div style="margin: 16px;">
          <van-button
            round
            block
            type="info"
            native-type="submit"
            :disabled="submitBtn"
          >{{submitText}}</van-button>
        </div>
      </van-form>
    </div>
    <div class="footer">
      {{footer}}
    </div>
  </div>
</template>

<script>
import { Form, Picker, Field, RadioGroup, Radio, Popup, Button, Calendar, Toast, Icon, Dialog } from 'vant'
import wx from 'weixin-js-sdk'

export default {
  name: 'App',
  components: {
    [Form.name]: Form,
    [Picker.name]: Picker,
    [Field.name]: Field,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Popup.name]: Popup,
    [Button.name]: Button,
    [Calendar.name]: Calendar,
    [Toast.name]: Toast,
    [Icon.name]: Icon,
    [Dialog.Component.name]: Dialog.Component
  },
  data() {
    return {
      topTip: "",
      pickerType: [],
      typeList: [],
      typeValue: '',
      typeIndex: '',
      showTypePicker: false,

      pickerTime: [],
      timeList: [],
      timeValue: '',
      showTimePicker: false,

      showCalendar: false,
      submitBtn: false,
      submitText: '提交',
      form: {
        type: '',
        unit: '',
        name: '',
        phone: '',
        booking_day: '',
        booking_time: '',
        booking_num: '',
      },
      minDate: '2021-06-01',
      maxDate: '2022-12-31',
      defaultList: {},
      footer: ''
    }
  },
  mounted: function () {
    this.getData()
    this.wxConfig()
  },
  methods: {
    getData() {
      this.$axios({
        method: 'get',
        url: '/getTxt',
      }).then(res => {
        if (res.data.code != 0) {
          Toast(res.data.msg)
          return false
        }
        this.footer = res.data.data.footer
        const typeList = res.data.data.place
        this.typeList = typeList
        this.topTip = res.data.data.tips
        this.pickerType = typeList.map(function (item) {
          return item.label
        })
      }).catch(() => {
        Toast('网络不好，请刷新')
      })
    },
    resetTime() {
      this.pickerTime = []
      this.timeList = []
      this.timeValue = ''
      this.form.booking_time = ''
    },
    // 确认展览点
    onConfirmType(value, index) {
      // 重新设置预约日期
      this.defaultList = {}
      this.minDate = '2021-06-01'
      this.maxDate = '2022-12-31'

      // 设置展览点信息
      this.typeIndex = index
      this.typeValue = value
      this.form.type = this.typeList[index].value

      this.form.booking_day = ''
      this.resetTime()
      this.showTypePicker = false

      this.$axios({
        method: 'get',
        url: '/getReservationDay',
        params: {
          type: this.typeList[index].value
        }
      }).then(res => {
        if (res.data.code != 0) {
          this.typeIndex = ''
          this.typeValue = ''
          this.form.type = ''
          Toast(res.data.msg)
          return false
        }

        // 设置预约日期
        const data = res.data.data
        this.defaultList = data.default_list
        this.minDate = data.range.min_date
        this.maxDate = data.range.max_date
      }).catch(() => {
        this.typeIndex = ''
        this.typeValue = ''
        this.form.type = ''
        Toast('网络不好，请重试')
      })
    },
    // 自定义日期文案
    formatter(day) {
      const list = this.defaultList
      let month = day.date.getMonth() + 1
      month = month <= 9 ? "0" + month : month

      let date = day.date.getDate()
      date = date <= 9 ? "0" + date : date
      const nowDate = `${day.date.getFullYear()}-${month}-${date}`
      if (list[nowDate]) {
        day.bottomInfo = list[nowDate]
        day.type = 'disabled'
      }
      return day
    },
    dayClick() {
      if (!this.form.type) {
        Toast('请选择展览点')
      } else {
        this.showCalendar = true
      }
    },
    timeClick() {
      if (!this.form.type) {
        Toast('请选择展览点')
      } else if (!this.form.booking_num) {
        Toast('请输入预约人数')
      } else if (!this.form.booking_day) {
        Toast('请选择预约日期')
      } else {
        const list = []
        const _that = this
        this.timeList.forEach(function (item) {
          const obj = {}
          obj['text'] = `${item.time} （可预约人数：${item.count}人）`
          if (_that.form.booking_num > item.count) {
            obj['disabled'] = true
          }
          list.push(obj)
        })
        this.pickerTime = list
        this.showTimePicker = true
      }
    },
    onConfirmTime(value, index) {
      this.timeValue = this.pickerTime[index].text
      this.form.booking_time = this.timeList[index].time
      this.showTimePicker = false
    },
    formatDate(date) {
      let m = date.getMonth() + 1
      m = m > 9 ? m : '0' + m
      let d = date.getDate()
      d = d > 9 ? d : '0' + d
      return `${date.getFullYear()}-${m}-${d}`
    },
    onConfirmDay(date) {
      this.showCalendar = false
      this.form.booking_day = this.formatDate(date)
      this.resetTime()
      this.getTimeData()
    },
    numInputChange() {
      this.form.booking_time = ''
      this.timeValue = ''
      if (this.form.booking_num > 150) {
        Toast({
          message: '每批次最多可预约150人，请安排分批次进行预约。',
          duration: 2500
        })
        this.form.booking_num = ''
      }
    },
    getTimeData() {
      this.$axios({
        method: 'get',
        url: '/getBooking',
        params: {
          type: this.form.type,
          day: this.form.booking_day
        }
      }).then(res => {
        if (res.data.code != 0) {
          Toast(res.data.msg)
          this.form.booking_day = ''
          return false
        }
        if (res.data.data.list.length <= 0) {
          Toast(this.form.booking_day + '不可预约，请重新选择')
          this.form.booking_day = ''
        } else {
          this.timeList = res.data.data.list
        }
      }).catch(() => {
        this.form.booking_day = ''
        Toast('网络不好，请重试')
      })
    },
    onSubmit() {
      this.submitBtn = true,
        this.submitText = '正在提交..'
      this.$axios({
        method: 'post',
        url: '/sign',
        data: this.form
      }).then(res => {
        this.submitBtn = false
        this.submitText = '提交'
        if (res.data.code != 0) {
          Toast(res.data.msg)
          return false
        }
        Dialog.alert({
          title: '预约成功',
          message: '请注意查收短信，凭短信入场。如没收到短信，可致电咨询展览点。'
        }).then(() => {
          window.location.reload()
        })
      }).catch(() => {
        Toast('提交失败，请重试')
        this.submitBtn = false
        this.submitText = '提交'
      })
    },
    validator(val) {
      if (val.length < 3) {
        return false
      } else {
        return true
      }
    },
    wxConfig() {
      this.$axios({
        method: 'get',
        url: '/getShare',
        params: {
          url: window.location.href
        }
      }).then(res => {
        const config = res.data.data
        const configdata = {
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: config.appId, // 必填，公众号的唯一标识
          timestamp: config.timestamp, // 必填，生成签名的时间戳
          nonceStr: config.nonceStr, // 必填，生成签名的随机串
          signature: config.signature, // 必填，签名
          jsApiList: [
            "updateAppMessageShareData",
            "updateTimelineShareData"
          ], // 必填，需要使用的JS接口列表
        }
        wx.config(configdata)
        wx.ready(() => {
          //自定义“分享给朋友”及“分享到QQ”按钮的分享内容
          wx.updateAppMessageShareData({
            title: '中山党史学习教育系列展预约系统', // 分享标题
            desc: '', // 分享描述
            link: 'https://huodong.zsnews.cn/huodong/2021/booking/index.html', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: 'https://huodong.zsnews.cn/huodong/2021/booking/images/share-logo.png', // 分享图标
            success: function () {
              // 设置成功
            }
          })

          //自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
          wx.updateTimelineShareData({
            title: '中山党史学习教育系列展预约系统', // 分享标题
            link: 'https://huodong.zsnews.cn/huodong/2021/booking/index.html', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: 'https://huodong.zsnews.cn/huodong/2021/booking/images/share-logo.png', // 分享图标
            success: function () {
              // 设置成功
            }
          })
        })
      })
    }
  }
}
</script>
<style>
body {
  background-color: #f7f8fa;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.title {
  padding: 4vw;
}
.top-tip {
  font-size: 14px;
  padding: 2vw 4vw;
  text-align: left;
  background-color: #fff;
  margin: 4vw;
  border-radius: 2vw;
  box-shadow: 0 1px 8px #ebedf0, 0 -1px 8px #ebedf0, 1px 0 8px #ebedf0;
  line-height: 1.8;
}
.hastip {
  padding-bottom: 1vw;
}
.hastip::after {
  border-bottom: none;
}
.line-tip {
  background-color: #fff;
  font-size: 12px;
  padding: 0 4vw 2vw;
  position: relative;
  color: #1989fa;
  text-align: right;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.line-tip::after {
  position: absolute;
  box-sizing: border-box;
  content: ' ';
  pointer-events: none;
  right: 16px;
  bottom: 0;
  left: 16px;
  border-bottom: 1px solid #ebedf0;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
}
#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
.container {
  flex: 1;
}
.footer {
  padding: 2vw;
  font-size: 12px;
  text-align: center;
}
.title {
  background-color: #1989fa;
  color: #fff;
  border-bottom: 1px solid #eee;
  margin-bottom: 4vw;
  line-height: 20px;
  height: 20px;
  font-size: 16px;
}
.form {
  background-color: #fff;
  margin: 0 4vw 4vw;
  border-radius: 2vw;
  box-shadow: 0 1px 8px #ebedf0, 0 -1px 8px #ebedf0, 1px 0 8px #ebedf0;
  overflow: hidden;
}
.top-tip a {
  color: #1989fa;
}
.top-tip p {
  margin-top: 5px;
  margin-bottom: 5px;
}
.container .van-button {
  /* width: 50%; */
  height: 36px;
  font-size: 16px;
  margin: 0 auto;
}
.van-calendar__popup {
  padding-bottom: 20px;
}
.van-icon-phone-o {
  font-size: 18px;
  margin-right: 5px;
}
.phone-wrap {
  display: flex;
  align-items: center;
}
.van-dialog__confirm,
.van-dialog__confirm:active {
  color: #1989fa;
}
</style>
